<template>

<div class="group l_min-footspace l_min-headspace" :ref="refs['quoteDelivery']">


  <div class="group-header l_no-footspace" :id="`${builder.panelFinish.fieldName}Title`">
    <div class="group-title">Schedule Delivery</div>
    <div class="group-help" v-if="builder.isKlBuilder">Within Adelaide Metro area. &nbsp;<a href="/support/delivery-information/" target="_blank" @click.stop.prevent="showDeliveryExplanation">Find out more</a></div>
    <div class="group-help" v-else><a href="/support/delivery-information/" target="_blank" @click.stop.prevent="showDeliveryExplanation">Delivery Info</a></div>
  </div>

  <Selector
    :key=builder.delivery.fieldName
    :field-name=builder.delivery.fieldName
    :display-type=builder.delivery.displayType
    :options="deliveryOptions"
    :selected=builder.quote[builder.delivery.fieldName]
    options-source="deliveryOptions"
    scope="quote"
    @select-option="updateDelivery"
  ></Selector>

  <div class="wardrobe-inner" id="your-postcode" style="margin-top: 10px;" v-if="!isPickup">
    <div class="wardrobe-main l_p0 l_wrap">
      <div class="wardrobe-cost l_promocode l_delivery">
        <label for="postcode" class="wardrobe-cost-label">Delivery Postcode</label>
        <div class="wardrobe-cost-input">
          <!-- <input
          type="text"
          id="promoCode"
          name="promoCode"
          placeholder="Enter your code here"
          v-model="promoCodeInput"
          @focus="$event.target.select()"
          @keydown.enter.prevent="updatePromoCode($event)"
          aria-required
          autocomplete="off"> -->
          <input
          type="text"
          name="postcode"
          id="postcode"
          autocapitalize="off"
          autocorrect="off"
          pattern="[0-9]{4}"
          maxlength="4"
          inputmode="numeric"
          v-model="postcodeValue"
          @change="updatePostcode()"
          @keydown.enter.prevent="updatePostcode()">
        </div>
      </div>
    </div>
  </div>

  <div class="wardrobe-inner" style="margin-top: 10px;" v-if="builder.quote[builder.delivery.fieldName] == 'request'">
    <div class="wardrobe-main l_p0 l_wrap">
      <div class="wardrobe-cost l_promocode l_delivery">
        <label for="promoCode" class="wardrobe-cost-label">Delivery Date Request</label>
        <div class="wardrobe-cost-input">
          <!-- <input
          type="text"
          id="promoCode"
          name="promoCode"
          placeholder="Enter your code here"
          v-model="promoCodeInput"
          @focus="$event.target.select()"
          @keydown.enter.prevent="updatePromoCode($event)"
          aria-required
          autocomplete="off"> -->
          <input
          type="date"
          name="deliveryDateRequest"
          v-model="deliveryDateValue"
          :min="deliveryDateMin"
          :max="deliveryDateMax"
          pattern="\d{4}-\d{2}-\d{2}"
          @change="updateDeliveryDate()"
          @keydown.enter.prevent="updateDeliveryDate()">
          <!-- <div class="feedback" v-if="promoCodeResponse || builder.quote.promoCodeApplied">
            <template v-if="builder.quote.promoCodeApplied">
              <svg class="icon"><use href="#check"></use></svg>
              Valid
            </template>
            <template v-else>
              Invalid
            </template>
          </div> -->
          <!-- <button class="button l_base l_strong" @click.stop="updatePromoCode($event)">Check</button> -->
        </div>
      </div>
    </div>
  </div>

  <div class="wardrobenotice l_light-blue" style="padding: 0;" v-if="isPickup && builder.delivery.pickupDetails.length">
    <div class="wardrobenotice-inner" v-html="builder.delivery.pickupDetails" style="margin-top: 20px; font-size: 80%;">
    </div>
  </div>

  <div class="wardrobenotice l_light-blue" style="padding: 0;" v-if="builder.quote.isCustomDelivery">
    <div class="wardrobenotice-inner" style="margin-top: 20px; font-size: 80%;">
      <p><template v-if="builder.quote.deliveryMessage"><strong>{{ builder.quote.deliveryMessage }}</strong>&nbsp;</template>Please contact us to arrange a custom delivery quote.</p>
    </div>
  </div>

  <div class="wardrobenotice l_error" style="padding: 0;" v-if="!builder.quote.isValidPostcode && !isPickup">
    <div class="wardrobenotice-inner" style="margin-top: 20px; font-size: 80%;">
      <p>Please enter a valid South Australian postcode.</p>
    </div>
  </div>

  <div class="wardrobenotice l_light-blue" style="padding: 0;" v-if="builder.quote.vanVolume > 1">
    <div class="wardrobenotice-inner" style="margin-top: 20px; font-size: 80%;">
      <p>Please note: your order requires multiple delivery slots due to its size.</p>
    </div>
  </div>

</div>

</template>

<script setup>

import { ref, onMounted, computed } from 'vue'

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

var _ = require('lodash');
const dayjs = require('dayjs')
import dayjsBusinessDays from 'dayjs-business-days';
dayjs.extend(dayjsBusinessDays);

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function updateDelivery(prop, opt) {
  let submitData = {};
  submitData[builder.delivery.fieldName] = opt['id'];
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
      deliveryDateValue.value = deliveryDate;
    }
  });
}

function updateDeliveryDate() {
  let submitData = {
    'deliveryDate': deliveryDateValue
  };
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
    }
  });
}

function updatePostcode() {
  // Validate postcode: only digits, up to 4 digits long
  const sanitizedPostcode = postcodeValue.value.replace(/\D/g, '').slice(0, 4);
  postcodeValue.value = sanitizedPostcode;

  let submitData = {
    'postcode': sanitizedPostcode
  };
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
    }
  });
}

function showDeliveryExplanation() {
  console.log('builder.delivery.details', builder.delivery.details);
  lightbox.open(builder.delivery.details);
}

const isPickup = computed(() => {
  return builder.quote[builder.delivery.fieldName] == 'pickup';
})

// dates
let now = dayjs()
const isNextBusinessDay = dayjs().format('H') > 17
const businessDays = 15 + ( isNextBusinessDay ? 1 : 0 )
const deliveryDateMin = now.businessDaysAdd(businessDays).format('YYYY-MM-DD')
const deliveryDateMax = now.businessDaysAdd(90).format('YYYY-MM-DD')
const deliveryDate = dayjs(builder.quote.deliveryDateRequest ?? deliveryDateMin).format('YYYY-MM-DD')
const deliveryDateValue = ref(deliveryDate)
const postcodeValue = ref(builder.quote.postcode)

// init refs
let refHandles = [
  'quoteDelivery',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});

</script>
